import { styled } from "@mui/material";
import Slider from "react-slick";

export const CustomSlider = styled(Slider)(
  ({ fontWeight = 700, textAlign = "left", width, justifyContent, gap }) => ({
    display: "flex !important",
    flexDirection: "column",
    justifyContent: justifyContent || "space-evenly",
    height: "100%",
    gap: gap,

    "& .slick-dots": {
      // bottom: "10px",
      position: "initial !important",
    },
  })
);
